/// <amd-module name="Agile/Common/Utils/Date" />
import { DateRange } from "Agile/Contracts/Date";
import { IIterationData } from "Agile/Contracts/Common";
/**
 * Convert a date object to UTC timezone.
 * @param localDate The date object to convert
 */
export function getUtcDate(localDate: Date): Date {
    return new Date(
        localDate.getUTCFullYear(),
        localDate.getUTCMonth(),
        localDate.getUTCDate(),
        localDate.getUTCHours(),
        localDate.getUTCMinutes(),
        localDate.getUTCSeconds(),
        localDate.getUTCMilliseconds()
    );
}

export function adjustDateRangeFromServer(dateRange: DateRange): DateRange {
    return { start: getUtcDate(dateRange.start), end: getUtcDate(dateRange.end) };
}

export function getLocalDate(utcDate: Date): Date {
    return new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60 * 1000);
}

export function getLocalDateRange(utcDateRange: DateRange): DateRange {
    return { start: getLocalDate(utcDateRange.start), end: getLocalDate(utcDateRange.end) };
}

export function getCurrentDate(): Date {
    // Reset the time object because we only care about the date.
    return new Date(new Date().setHours(0, 0, 0, 0));
}

export function adjustIterationDatesFromServer(iteration: IIterationData): IIterationData {
    return {
        ...iteration,
        startDate: iteration.startDate ? getUtcDate(iteration.startDate) : undefined,
        finishDate: iteration.finishDate ? getUtcDate(iteration.finishDate) : undefined
    };
}

/**
 * Add days to a date. This is DST safe since it doesn't use getTime() for the adjustment.
 * @param date The date to add days to
 * @param days Number of days to add
 */
export function addDays(date: Date, days: number): Date {
    return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + days,
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    );
}
